'use client'
import React from 'react'
import LocationIntro from '../../sections/locationIntro'
import CtaSection from '../../sections/ctaSection'

import Locations from '../../sections/locations'

import PageWrapperMainSite from '../../pageWrapper'
import FaqSection from '../../sections/faq'

import BreadCrumbs from '../../sections/breadcrumbs'
import StaticMapSection from '../../sections/mapsStatic'
import EventCalendarHome from '../../sections/eventsCalendarHome'

const SportsDetailPage = ({
  title,
  intro_text,
  info_lists,
  get_snel_naar,
  body,
  cta,
  locations,
  breadcrumbs,
  faq,
  allLocations,
  sports,
  global_tags,
  type_provider,
  events,
  clubAddresses,
}) => {
  const intro_link = get_snel_naar && get_snel_naar[0] && get_snel_naar[0].value

  const {
    link: cta_cta,
    image: cta_image,
    text: cta_text,
  } = cta?.length ? cta[0].value : {}

  const cta_link = cta_cta
    ? {
        text: cta_cta?.text,
        href: cta_cta?.href ? cta_cta?.href : cta_cta?.external_url,
      }
    : {}

  const sportTitles = sports?.map((item) => item.title)
  let ages = []
  let groups = []
  let aangepaste_sporten = []
  global_tags.forEach((item) => {
    if (item.global_attribute == 'Levensfase') {
      ages.push(item.title)
    } else if (item.global_attribute == 'Speciale doelgroep') {
      groups.push(item.title)
    } else if (item.global_attribute == 'Aangepaste sporten') {
      aangepaste_sporten.push(item.title)
    }
  })
  const specials = [...groups, ...aangepaste_sporten]
  const infoRows = [
    {
      title: 'Sport',
      first_column: sportTitles?.length ? sportTitles.join(', ') : '-',
    },
    {
      title: 'Voor wie',
      first_column: ages?.length ? ages.join(', ') : '-',
    },
    {
      title: 'Speciaal aanbod voor',
      first_column: specials?.length ? specials.join(', ') : '-',
    },
    {
      title: 'Type aanbieder',
      first_column: type_provider
        ? type_provider?.charAt(0)?.toUpperCase() + type_provider?.slice(1)
        : '',
    },
  ]
  const coordinates = allLocations?.map((item) => {
    return `${item.lat},${item.lng}`
  })

  return (
    <>
      <div style={{ paddingTop: '30px' }}>
        <BreadCrumbs breadcrumbs={breadcrumbs} spacing={60} />
      </div>
      <LocationIntro
        intro={intro_text}
        body={body}
        lists={info_lists}
        link={intro_link}
        infoRows={infoRows}
        isClub={true}
        addresses={clubAddresses}
      />
      {cta_link && cta_text && cta_image && (
        <CtaSection cta={cta_link} text={cta_text} image={cta_image} />
      )}

      {locations?.length ? (
        <Locations
          title={`Locaties van ${title}`}
          text=""
          perPage={6}
          locations={locations}
          totalCount={locations.length}
          background="#F4F6F8"
        />
      ) : null}

      {events?.length ? (
        <EventCalendarHome
          title="Aankomende evenementen"
          events={events}
          hideButton={true}
        />
      ) : null}

      {faq?.length ? (
        <FaqSection
          title={`Veelgestelde vragen over ${title}`}
          questions={faq}
        />
      ) : null}
      {coordinates && (
        <StaticMapSection
          locations={coordinates}
          width={600}
          height={600}
          title={title}
          markersOnly
        />
      )}
    </>
  )
}

export default SportsDetailPage
